'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _components2 = require('components');

var _pacomo = require('utils/pacomo');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SavingModal = function SavingModal(_ref) {
    var isSubmitting = _ref.isSubmitting;

    return _react2.default.createElement(
        'div',
        {
            tabIndex: '-1',
            role: 'dialog',
            className: isSubmitting ? 'is-visible' : ''
        },
        _react2.default.createElement('div', { className: 'overlay' }),
        _react2.default.createElement(
            'div',
            { className: 'modal-dialog', role: 'document' },
            _react2.default.createElement(
                'div',
                { className: 'modal-content' },
                _react2.default.createElement(
                    'div',
                    { className: 'modal-header' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'savingModal.saving',
                        defaultMessage: 'Saving' }),
                    _react2.default.createElement(_components2.IconLoading, { inline: true })
                )
            )
        )
    );
};

SavingModal = (0, _pacomo.pacomoTransformer)(SavingModal);

var FormSubmit = function FormSubmit(_ref2) {
    var handleSubmit = _ref2.handleSubmit,
        invalid = _ref2.invalid,
        pristine = _ref2.pristine,
        submitting = _ref2.submitting,
        submitSucceeded = _ref2.submitSucceeded,
        isFetchingRequirementData = _ref2.isFetchingRequirementData,
        _ref2$hoisted = _ref2.hoisted,
        hoisted = _ref2$hoisted === undefined ? false : _ref2$hoisted;


    // submitting only tells us if the resource update is finished, we want to only stop showing submitting
    // once the requirements subresource is reloaded after the finished update
    var isSubmitting = submitting || submitSucceeded && isFetchingRequirementData;
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)({
                    'hoisted': hoisted,
                    'column': !hoisted
                }) },
            _react2.default.createElement(
                'div',
                { className: 'submit' },
                _react2.default.createElement(
                    'button',
                    {
                        type: 'submit',
                        className: (0, _classnames2.default)({
                            'submitting': isSubmitting
                        }),
                        disabled: pristine || invalid || isSubmitting,
                        onClick: handleSubmit },
                    _react2.default.createElement(SavingModal, {
                        isSubmitting: isSubmitting
                    }),
                    !isSubmitting && _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formButtons.save' }),
                    isSubmitting && _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formButtons.saving' })
                )
            )
        )
    );
};
FormSubmit.propTypes = {
    handleSubmit: _propTypes2.default.func.isRequired,
    invalid: _propTypes2.default.bool,
    pristine: _propTypes2.default.bool,
    submitting: _propTypes2.default.bool.isRequired,
    submitSucceeded: _propTypes2.default.bool.isRequired,
    isFetchingRequirementData: _propTypes2.default.bool.isRequired
};

exports.default = (0, _pacomo.pacomoTransformer)(FormSubmit);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/forms/FormSubmit.js
// module id = 309
// module chunks = 0